import { Expose } from 'class-transformer';
import { IsEnum, IsObject, IsOptional, IsString } from 'class-validator';
import CreatedInfo, { Created } from './created-info';
import ModifiedInfo, { Modified } from './modified-info';
import ProfileRole from './profile-role';
import ProfileStatus from './profile-status';

export class PersonProfile implements Created, Modified {
  @IsString()
  readonly id: string;

  @IsString()
  @Expose({ name: 'condominium_id' })
  @IsOptional()
  readonly condominiumId?: string | null;

  @IsString()
  @Expose({ name: 'unit_id' })
  @IsOptional()
  readonly unitId?: string | null;

  @IsEnum(ProfileRole)
  readonly role: ProfileRole;

  @IsEnum(ProfileStatus)
  @IsOptional()
  readonly status?: ProfileStatus;

  @IsOptional()
  @IsObject()
  readonly created?: CreatedInfo;

  @IsOptional()
  @IsObject()
  readonly modified?: ModifiedInfo;

  @IsOptional()
  @IsObject()
  readonly deleted?: ModifiedInfo;

  constructor(init?: PersonProfile | Partial<PersonProfile>) {
    this.id = init?.id!;
    this.condominiumId = init?.condominiumId;
    this.role = init?.role!;
    this.unitId = init?.unitId;
    this.status = init?.status;
    this.created = init?.created ? new CreatedInfo(init?.created!) : undefined;
    this.modified = init?.modified ? new ModifiedInfo(init?.modified) : undefined;
    this.deleted = init?.deleted ? new ModifiedInfo(init?.deleted) : undefined;
  }
}

export default PersonProfile;
